import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Depositos } from './Depositos';
import { Inventario } from './Inventario';
import { Lotes } from './Lotes';
import { Movimentacoes } from './Movimentacoes';
import { Produtos } from './Produtos';
import { Reposicao } from './Reposicao';
import { Variacoes } from './Variacoes';
import { i18n } from './i18n';
import { buscaEstoque } from './busca-global';

const modulo: ModuloWeb = {
  slug: 'estoque',
  menu: 'operacao',
  ordem: 10,
  abas: [
    // Fase 2 (W6, L1): a aba Produtos mora em Cadastros (o dado continua do Estoque).
    { chave: 'produtos', permissao: 'estoque.ver', componente: Produtos, menu: 'cadastros', grupo: 'estoque', posicao: 110 },
    { chave: 'variacoes', permissao: 'estoque.ver', componente: Variacoes },
    { chave: 'depositos', permissao: 'estoque.ver', componente: Depositos },
    { chave: 'movimentacoes', permissao: 'estoque.ver', componente: Movimentacoes },
    { chave: 'reposicao', permissao: 'estoque.ver', componente: Reposicao },
    { chave: 'inventario', permissao: 'estoque.ver', componente: Inventario },
    { chave: 'lotes', permissao: 'estoque.ver', componente: Lotes },
  ],
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaEstoque,
};

export default modulo;
